import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/uat-a/cs-mobile-next/app/components/newsletters/NewslettersIndex.tsx");
